/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiScenarioVersionParameterTimeUnit {
    HOUR = 'HOUR',
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH'
}


export function instanceOfInternalApiScenarioVersionParameterTimeUnit(value: any): boolean {
    for (const key in InternalApiScenarioVersionParameterTimeUnit) {
        if (Object.prototype.hasOwnProperty.call(InternalApiScenarioVersionParameterTimeUnit, key)) {
            if (InternalApiScenarioVersionParameterTimeUnit[key as keyof typeof InternalApiScenarioVersionParameterTimeUnit] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiScenarioVersionParameterTimeUnitFromJSON(json: any): InternalApiScenarioVersionParameterTimeUnit {
    return InternalApiScenarioVersionParameterTimeUnitFromJSONTyped(json, false);
}

export function InternalApiScenarioVersionParameterTimeUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioVersionParameterTimeUnit {
    return json as InternalApiScenarioVersionParameterTimeUnit;
}

export function InternalApiScenarioVersionParameterTimeUnitToJSON(value?: InternalApiScenarioVersionParameterTimeUnit | null): any {
    return value as any;
}

export function InternalApiScenarioVersionParameterTimeUnitToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiScenarioVersionParameterTimeUnit {
    return value as InternalApiScenarioVersionParameterTimeUnit;
}

